export default __webpack_public_path__ + "static/media/propic2.17bdc688.jpg";